import React from 'react';

export default function Events(){
  return (
    <main style={{padding:24}}>
      <h1>Events</h1>
      <p>Keep an eye out for trade shows and product demos.</p>
    </main>
  );
}
